import React, { useEffect, useState } from "react";
import {
  Bar,
  BarChart,
  CartesianAxis,
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import {
  Flex,
  Heading,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";

const YearlyEarningChart = ({ data }) => {
  const noDataBgColor = useColorModeValue("#fff", "#081b2e");
  const [yearlyData, setYearlyData] = useState([]);
  const [yearlyTotalAmount, setYearlyTotalAmount] = useState(0);

  //calculate yearly data
  const calculateYearlyData = (earningsData) => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const currentYear = new Date().getFullYear();
    const yearlyAmounts = {};

    earningsData.forEach((entry) => {
      const date = new Date(entry.created_at);
      const entryYear = date.getFullYear();
      const entryMonth = date.getMonth();
      const amount = parseFloat(entry.amount);

      if (entryYear === currentYear) {
        if (!isNaN(amount)) {
          if (yearlyAmounts[entryMonth]) {
            yearlyAmounts[entryMonth] += amount;
          } else {
            yearlyAmounts[entryMonth] = amount;
          }
        }
      }
    });

    const formattedYearlyData = months.map((month, index) => ({
      month,
      amount: yearlyAmounts[index]?.toString() || "0",
    }));

    return formattedYearlyData;
  };
  ////end of calculateWeeklyData()//

  useEffect(() => {
    setYearlyData(calculateYearlyData(data));
    console.log("yearlyData:", yearlyData);
  }, [data]);

  // Sort the yearly data by month
  const sortedYearlyData = yearlyData?.sort((a, b) => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return months.indexOf(a.month) - months.indexOf(b.month);
  });

  // Calculate the total sum of amounts
  const totalSum = sortedYearlyData?.reduce((sum, entry) => {
    const finalSum = sum + parseFloat(entry.amount);
    return finalSum;
  }, 0);

  const formattedTotalSum = formatAmount(totalSum);

  function formatAmount(amount) {
    if (amount >= 1000000) {
      return (amount / 1000000).toFixed(1) + "m";
    } else if (amount >= 1000) {
      return (amount / 1000).toFixed(1) + "k";
    }
    return amount.toString();
  }

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const month = payload[0].name;
      return (
        <div
          className="custom-tooltip"
          style={{
            backgroundColor: "white",
            padding: "5px",
            borderRadius: "5px",
          }}
        >
          <p className="label">{month}</p>
          <p className="label">{`Amount: $${payload[0].value}`}</p>
        </div>
      );
    }

    return null;
  };

  // Calculate the maximum amount, let it be the highest YAxis value
  const maxAmount = Math.max(
    ...yearlyData.map((entry) => parseFloat(entry.amount))
  );

  const noDataStyles = {
    p: "10px",
    borderRadius: "5px",
    boxShadow: "3px 8px 13px 0px #8080800f",
    bg: noDataBgColor,
    w: "100%",
    fontSize: ".9em",
  };

  return (
    <>
      {formattedTotalSum > 0 ? (
        <Stack direction={"row"} mb="20px" justifyContent={"space-between"}>
          <Stack direction={"column"} gap={20}>
            <Heading fontSize="1.5em">Yearly Earnings</Heading>

            <Heading>${formattedTotalSum}</Heading>
          </Stack>

          <ResponsiveContainer width="100%" height={400}>
            {yearlyData?.length > 0 ? (
              <BarChart
                data={yearlyData}
                margin={{
                  top: 10,
                  left: 20,
                  right: 20,
                  bottom: 10,
                }}
              >
                <CartesianGrid strokeDasharray="3 3"></CartesianGrid>
                <XAxis dataKey="month" />
                <YAxis domain={[0, maxAmount]} />
                <Tooltip content={<CustomTooltip />} />
                <Legend />
                <Bar dataKey="amount" fill="#4f46ba" />
              </BarChart>
            ) : (
              <p>Loading...</p>
            )}
          </ResponsiveContainer>
        </Stack>
      ) : (
        <Stack
          direction={"column"}
          mb="20px"
          justifyContent={"center"}
          {...noDataStyles}
        >
          <Heading fontSize="1.5em">Yearly Earnings</Heading>

          <Text textAlign={"center"}>No data at the moment</Text>
        </Stack>
      )}
    </>
  );
};

export default YearlyEarningChart;
